<template>
  <div :class="classNames" v-if="showFlag"></div>
</template>

<script>
import { store as BootstrapStore } from "../../store/Bootstrap";

export default {
  data() {
    return {
      showFlag: false,
      showClass: false
    };
  },
  computed: {
    showing() {
      return BootstrapStore.showModal;
    },
    classNames() {
      return {
        "modal-backdrop": true,
        fade: true,
        show: this.showClass
      };
    }
  },
  watch: {
    showing: {
      immediate: true,
      handler: function(newVal) {
        if (newVal) {
          this.showFlag = true;
          setTimeout(() => {
            this.showClass = true;
          }, 10);
        } else {
          this.showClass = false;
          setTimeout(() => {
            this.showFlag = false;
          }, 100);
        }
      }
    }
  }
};
</script>
